export default __webpack_public_path__ + "static/media/kassim_logo.03606071.png";